import axios from "axios";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class FerryBookingService {

  static ferrySearch(item) {

    let api = '';
    
    
    api = `${API_BASE_URL}${API_PATHS.ferrySearch}`;
    
      return axios
       .post(api,item)
       .then((response) => {
         if (response.data) {
         }
         return response.data;
       })
       .catch((error) => {
         console.error("Error:", error);
         throw error;
       });
   }

  
}

export default FerryBookingService;